import { i18n } from '@/plugins/i18n'

export const userTypes = {
    REAL: 1,
    LEGAL: 2,
}

export const userTypesStr = {
    REAL: i18n.t('user_types.real'),
    LEGAL: i18n.t('user_types.legal'),

    get(user_type) {
        let user_type_str = null;

        Object.keys(userTypes).forEach(function (item, index) {
            if(userTypes[item] === user_type) {
                user_type_str = userTypesStr[item];
            }
        });

        return user_type_str;
    }
}
